import React, { FC } from 'react';

import { FetchDccRecordingReturn } from 'types';
import { useAlarmId } from '../../useAlarmId';
import { RecordingBox } from '../recordingPlayer';

type RecordingProps = {
  recording: FetchDccRecordingReturn;
};

/** The conference recording of the legacy call: plays up to the moment the first person joined. */
const Recording: FC<RecordingProps> = ({ recording }) => {

  const alarmId = useAlarmId();

  return (
    <RecordingBox
      key={`legacy:${alarmId}`}
      url={recording.url}
      recordingKey={`legacy:${alarmId}`}
      limit={recording.firstJoinMs ? recording.firstJoinMs / 1000 : null}
    />
  );

};

export default Recording;
